import React, { useEffect, useState } from "react";

import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import TaskIcon from "@mui/icons-material/Task";
import { Avatar, Card, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Getrequestcall } from "../../request/Getrequest";
import defaultAvatar from "../../assets/images/avtar_placeholder.jpeg";
import Loader from "../../common/Loader";
import { GET_CLIENT_DASHBOARD_NOTIFICATIONS } from "../../constant/Apipath";

function ClientNotification() {
  const { loginData } = useSelector((state) => state?.main);
  const { selectedClientData } = useSelector((state) => state?.main);
  const { id } = useParams();

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [dashboardNotification, setDashboardNotification] = useState([]);

  useEffect(() => {
    if (id) {
      getInitialData();
    }
  }, [id]);

  const getInitialData = async () => {
    await getDashboardNotification();
  };
  const getDashboardNotification = async () => {
    setIsLoading(true);
    try {
      const response = await Getrequestcall(
        GET_CLIENT_DASHBOARD_NOTIFICATIONS + `${selectedClientData?.ClientEmployeeId || id}/`,
        loginData?.accessToken
      );
      if (response?.status === 200) {
        const data = response?.data?.data ?? [];
        setDashboardNotification(data);
      }
    } catch (error) {
      console.error("getDashboardNotification-> Error Getting Dashboard Notification :: ", error);
    }
    setIsLoading(false);
  };

  const decorateText = (text) => {
    return text.replace(/<([^>]+)>/g, (match, content) => {
      return `<strong>${content}</strong>`;
    });
  };

  const getIconByModuleName = (moduleName) => {
    const iconMap = {
      "Timesheets Approved": (
        <EventAvailableIcon sx={{ color: selectedClientData?.AccentColor, fontSize: "2.4rem" }} />
      ),
      "Timesheets Rejected": (
        <EventBusyIcon sx={{ color: selectedClientData?.AccentColor, fontSize: "2.4rem" }} />
      ),
      "Expenses Approved": (
        <TaskIcon sx={{ color: selectedClientData?.AccentColor, fontSize: "2.4rem" }} />
      ),
      "Expenses Rejected": (
        <AssignmentLateIcon sx={{ color: selectedClientData?.AccentColor, fontSize: "2.4rem" }} />
      ),
      Miscellaneous: <Avatar src={defaultAvatar} />
    };

    return iconMap[moduleName] || <Avatar src={defaultAvatar} />;
  };

  const handleNotificationCLick = (data) => {

    switch (data?.title) {
      case "Actions":
      case "Actions Status":
        navigate(
          `/client/${selectedClientData?.ClientId}/actions/actions-details/${data.recordId}`
        );
        break;
      case "Communicator":
        navigate(`/client/${selectedClientData?.ClientId}/communicator`, {
          state: { id: data.recordId }
        });
        break;
      case "Coaching":
        navigate(`/client/${selectedClientData?.ClientId}/coaching`);
        break;
      case "Timesheets Approved":
      case "Timesheets Rejected":
      case "Timesheets Review":
        navigate(`/client/${selectedClientData?.ClientId}/timesheets`);
        break;
      case "Expenses Approved":
      case "Expenses Rejected":
        navigate(`/client/${selectedClientData?.ClientId}/expenses`, {
          state: { id: data.recordId }
        });
        break;
      case "Change Tracker":
        navigate(`/client/${selectedClientData?.ClientId}/change-tracker`, {
          state: { id: data.recordId }
        });
        break;
      case "Picture Board":
        navigate(`/client/${selectedClientData?.ClientId}/picture-board`, {
          state: { id: data.recordId }
        });
        break;
      case "Support":
        navigate(`/client/${selectedClientData?.ClientId}/support-requests`, {
          state: { id: data.recordId, custom: data.custom1 }
        });
        break;
      default:
        return;
    }
  };

  const CustomListing = ({ data, index }) => {

    return (
      <Card
        key={index}
        onClick={() => handleNotificationCLick(data)}
        sx={{
          backgroundColor: data?.color,
          padding: "10px",
          boxShadow: "none",
          borderRadius: "10px",
          border: "none"
        }}>
        <Stack spacing={1} direction="row">
          <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
            {data?.custom4 === "Individual" || data?.custom4 === "" ? (
              getIconByModuleName(data?.title)
            ) : (
              <Avatar src={data?.custom4} />
            )}
            <Typography variant="body1">{data?.userName}</Typography>
          </Stack>
          <Stack direction="column">
            <div
              dangerouslySetInnerHTML={{
                __html: decorateText(data?.description || "")
              }}
            />
            <Typography variant="body1" sx={{ color: "grey" }}>
              {dayjs(data?.notificationDate).format("MMMM DD, YYYY")}
            </Typography>
          </Stack>
        </Stack>
      </Card>
    );
  };

  return (
    <>
      <Stack sx={{ gap: 1,  display: "flex"  }} >
        {isLoading ? (
          <Loader fullScreen />
        ) : (
          <>
            {dashboardNotification?.map((data, index) => (
              <CustomListing key={index} index={index} data={data} />
            ))}
          </>
        )}
      </Stack>
    </>
  );
}

export default ClientNotification;

